import { useContext, useRef, useMemo, useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles'

import { loadStripe } from '@stripe/stripe-js'
import { Drawer, Button } from '@mui/material'
import EastRoundedIcon from '@mui/icons-material/EastRounded'
import { enqueueSnackbar } from 'notistack'

import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js'

import { AppContext } from '/providers/app-context'
import { getStripePublicKey, setupStripeSession } from '/providers/studio-api'

const StripePaymentForm = ({ open, setOpen, checkoutComplete }) => {
  const theme = useTheme();

  const { apiSource, apiKeys } = useContext(AppContext)
  const [stripeKey, setStripeKey] = useState()

  const sessionId = useRef(null)

  useEffect(() => {
    if (open && !stripeKey)
      loadStripeKey()
  }, [open])

  const loadStripeKey = async () => {
    const result = await getStripePublicKey({ apiSource, apiKeys })

    if (result.ok) setStripeKey(result.publicKey)
      else enqueueSnackbar({message:result.error,variant:"error"})
  }

  const stripePromise = useMemo(() => {
    if (stripeKey) {
      return loadStripe(stripeKey)
    }
  }, [stripeKey])

  const fetchClientSecret = async () => {
    const result = await setupStripeSession({
      apiSource, apiKeys, stripe_options: {
        payment_method_types: ["card"]
      }
    })

    if (result.ok) {
      sessionId.current = result.session.id
      return result.session.client_secret
    }
    else enqueueSnackbar({message:result.error,variant:"error"})
  }

  const close = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    setOpen(false)
  }

  const options = useMemo(() => {
    const handleCheckoutComplete = () => {
      checkoutComplete(sessionId.current)
      setTimeout(() => close(), 3000)
    }

    return {
      fetchClientSecret,
      onComplete: handleCheckoutComplete,
    }
  }, [])


  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={close}
      sx={{
        width: 500,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: 500,
          boxSizing: 'border-box',
          backgroundColor: "#ffffff",
          paddingTop: 10
        },
      }}
    >

      <div className="flex flex-row justify-end mr-5 mb-10">
        <Button endIcon={<EastRoundedIcon />} onClick={close} sx={{ color: "red" }}>cancel</Button>
      </div>

      {stripePromise &&
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={options}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      }
    </Drawer>
  )
}

export default StripePaymentForm
